<template>
    <v-dialog 
        :value="mapFilterDialog"
        @input="closeMapFiltersDialog()" 
        max-width="800px"
        scrollable
    >
        <v-card>
            <v-app-bar
                height="40" 
                width="100%" 
                class="pa-0"
                elevate-on-scroll
                scroll-target="#widget-container"
            >
            <v-row >
                <v-col 
                    class="pl-0" 
                    cols="1"
                >
                    <div>
                        <v-btn 
                            icon 
                            @click.prevent="closeMapFiltersDialog()"
                            :ripple="false"
                        >
                            <v-icon color="black">
                                mdi-close
                            </v-icon>
                        </v-btn>
                    </div>
                </v-col>
                
                <v-col 
                    cols="10" 
                    class="d-flex justify-space-around"
                >
                    <v-toolbar-title class="font-weight-bold">
                        {{ $t("sidebar.section.filters") }}
                    </v-toolbar-title>
                </v-col>
            </v-row>
            </v-app-bar>	
            <v-sheet
                id="widget-container"
                class="overflow-y-auto"
            >
                <v-divider></v-divider>
                <div class="pt-4 pr-6 pl-6">
                    <div 
                        class="point" 
                        v-for="(point, id) in data.points" 
                        :key="`point-${id}`"
                    >
                        <v-list 
                            class="props-list props-list_wide" 
                            expand
                        >
                            <v-list-group 
                                :value="true" 
                                :ripple=false 
                                color="black" 
                                class="pt-6"
                            >
                                <template v-slot:activator>
                                    <v-list-item-title>
                                        <div class="scrolable-box-heading">
                                            <h3>
                                                {{point.text}}
                                            </h3>
                                        </div>
                                    </v-list-item-title>
                                </template>
                                <v-list-item 
                                    v-for="(item, id) in point.categories" 
                                    :key="`category-${id}`" 
                                    class="pl-4"
                                >
                                <a
                                    href="#"
                                    class="d-flex"
                                    :class="{ 'active': item.active }"
                                    @click.prevent="toggleState(item)"
                                >
                                    <span class="icon-holder pr-2">
                                        <svg
                                            width="20"
                                            height="20"
                                        >
                                            <image
                                                v-if="item.active"
                                                :xlink:href="item.icon"
                                                :src="item.icon"
                                                width="20"
                                                height="20"
                                            />
                                            <image
                                                v-else
                                                :xlink:href="item.inactiveIcon"
                                                :src="item.inactiveIcon"
                                                width="20"
                                                height="20"
                                            />
                                        </svg>
                                    </span>
                                    <span class="pb-1">
                                        {{ item.text }}
                                    </span>
                                </a>
                                </v-list-item>
                            </v-list-group>
                        </v-list>
                    </div>
                </div>
                <v-divider></v-divider>
                <v-card-actions class="px-6" >
                    <v-spacer></v-spacer>
                    <v-btn 
                        @click.prevent="applyFilters()" 
                        class="text-none" 
                        color="success"
                    >
                        {{ $t('map.showResult') }}
                    </v-btn>
                </v-card-actions>
            </v-sheet>	
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "MapFiltersDialog",
        props: [
            "data",
            "mapFilterDialog"
        ],
        methods: {
            applyFilters() {
                this.$emit("apply-filters");
                this.closeMapFiltersDialog();
            }, 
            closeMapFiltersDialog(){
                this.$emit("close");
            },
            toggleState(item) {
                this.$set(item, 'active', !item.active);
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/layout/alternative/map/components/MapFiltersDialog.vue